import React, { useEffect, useMemo, useState } from 'react'
import { Badge, Card, Container, Dropdown } from 'react-bootstrap'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { FaBus } from 'react-icons/fa'
// import { useState } from 'react'
import { LuGraduationCap } from 'react-icons/lu'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { useNavigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { BsEyeFill, BsPersonPlusFill, BsThreeDotsVertical } from 'react-icons/bs'
import ApiEndpoints from './commonComponents/ApiEndpoints'
import { Modal, Form } from "react-bootstrap";
import EditBusModal from './EditBusModal'
import { toast } from 'react-hot-toast';
import { BsPencilFill} from 'react-icons/bs'
import { MdOutlineDeleteForever } from "react-icons/md";
import DeleteBusModal from './DeleteBusModal'
import { useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import axios from 'axios'
import { BASE_URL } from './commonComponents/ApiEndpoints'
import { BsFunnelFill } from 'react-icons/bs'
import { BsSearch,BsArrowClockwise } from 'react-icons/bs'
import {Row,Col} from 'react-bootstrap'
import { useRef } from 'react'
import SelectableField from './commonComponents/SelectableField'


export default function AssigningBustoStd() {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState([]);
  
  const tableRef = useRef(null);
  const [students, setStudents] = useState([])
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();


  // adding bus data
  const [buses, setBuses] = useState([]);
  // const [loading, setLoading] = useState(false);


const [showEditModal, setShowEditModal] = useState(false);
const [selectedBus, setSelectedBus] = useState(null);
  const [mode, setMode] = useState(""); // "view" or "edit"
// const [students, setStudents] = useState([])
// const [selectedStudents, setSelectedStudents] = useState([])
// const [busId, setBusId] = useState(null)
const { busId } = useParams()

// filters
const [search, setSearch] = useState("")
  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);
 

//  const [students, setStudents] = useState([])
  const [selectedStudents, setSelectedStudents] = useState([])

  // adding filter and searching 
const [showFilterCard, setShowFilterCard] = useState(true);
const [itemsPerPage, setItemsPerPage] = useState(10);
const [currentPage, setCurrentPage] = useState(1);
const [selectedCourse, setSelectedCourse] = useState('');
const [selectedClass, setSelectedClass] = useState('');
const [selectedStudentId, setSelectedStudentId] = useState('');
const [data, setData] = useState([]);
const [resetKey, setResetKey] = useState(0);


  const handleRefresh = () => {
  // setSearch("");
  // setSelectedStudents([]);
  // fetchStudents();
  setSearch("");
  setSelectedStudents([]);
  setSelectedCourse("");
  setSelectedClass("");
  setSelectedStudentId("");
  setData(students); // ✅ restore data immediately
  setResetKey(prev => prev + 1); // ✅ IMPORTANT
};


useEffect(() => {
  const userCookie = Cookies.get('user');

  if (userCookie) {
    try {
      const parsedUser = JSON.parse(userCookie);
      setUser(parsedUser);
      setUserRole(parsedUser);
    } catch (err) {
      console.error("User parse error", err);
    }
  }
}, []);



  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1
        setMarginLeft(
          isCollapsed ? `${collapsedWidth + gap}px` : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }
      setIsMobile(window.innerWidth <= 768)
    }

    
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  // ✅ Fetch all students
  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    try {
      const instituteId = Cookies.get('institute_id')
      const user = JSON.parse(Cookies.get('user') || '{}')

      const res = await axios.get(`${BASE_URL}/student/all`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
          'Institute-Id': Number(instituteId)}})

      setStudents(res.data?.data || []);
setData(res.data?.data || []);
    } catch (error) {
      console.error(error)
      toast.error('Failed to fetch students')
    }
  }


const handleFilterSelect = (values) => {
  console.log("Filter Values:", values);

  // ✅ ignore empty trigger
  if (!values.course && !values.class && !values.student) {
    return;
  }

  let filtered = [...students];

  if (values.course) {
    filtered = filtered.filter(
      (s) => Number(s.course_id) === Number(values.course)
    );
  }

  if (values.class) {
    filtered = filtered.filter(
      (s) => Number(s.class_id) === Number(values.class)
    );
  }

  if (values.student) {
    filtered = filtered.filter(
      (s) => Number(s.id) === Number(values.student)
    );
  }

  // ✅ correct logic (ONLY ONE setData)
  setData(filtered.length ? filtered : students);
};


  // ✅ Handle checkbox (single)
  const handleSelect = (studentId) => {
    setSelectedStudents((prev) =>
      prev.includes(studentId)
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId]
    )
  }

  // ✅ Select All
  const handleSelectAll = () => {
    if (selectedStudents.length === currentStudents.length) {
      setSelectedStudents([])
    } else {
      setSelectedStudents(currentStudents.map((s) => s.id))
    }
  }

  // ✅ Assign Bus API (single + multiple)
  const assignBus = async () => {
    if (selectedStudents.length === 0) {
      return toast.error('Select at least one student')
    }

    try {
      const instituteId = Cookies.get('institute_id')
      const user = JSON.parse(Cookies.get('user') || '{}')

      const headers = {
        Authorization: `Bearer ${user.token}`,
        'Content-Type': 'application/json',
        'Institute-Id': Number(instituteId)}

      // 🔥 Loop for multiple students
      const responses = await Promise.all(
        selectedStudents.map((studentId) =>
          axios.post(
            `${BASE_URL}/transport/assign-bus`,
            {
              student_id: studentId,
              bus_id: busId},
            { headers }
          )
        )
      )

      const successMessage =
        responses?.[0]?.data?.message ||
        (selectedStudents.length > 1
          ? 'Vehicles assigned successfully'
          : 'Vehicle assigned successfully')

      toast.success(successMessage)
      setSelectedStudents([])

    } catch (error) {
      console.error(error)
      toast.error(
        error.response?.data?.message ||
          error.message ||
          'Assignment failed'
      )
    }
  }

const filteredStudents = useMemo(() => {
  let temp = data; // ✅ use filtered data

  if (!search.trim()) return temp;

  return temp.filter((student) =>
    Object.values(student).some((val) =>
      val &&
      val.toString().toLowerCase().includes(search.toLowerCase())
    )
  );
}, [data, search]);

const totalPages = Math.ceil(filteredStudents.length / itemsPerPage);

const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const currentStudents = filteredStudents.slice(
  indexOfFirstItem,
  indexOfLastItem
);


useEffect(() => {
  setCurrentPage(1);
}, [search, itemsPerPage]);
  
  return (
    <>
      <style> 
        {`
          .page-title {
            font-family: 'Inter', system-ui, sans-serif;
            letter-spacing: -0.02em;
            color: #223843;
          }
          .modern-card {
            background: #ffffff;
            border: 1px solid #D1D3D4;
            border-radius: 12px;
            overflow: visiable;
          }
          /* Match CreateNotification.js premium table behavior */
          .table td {
            overflow: visible !important;
            user-select: text;
          }
          .table tbody tr {
            overflow: visible !important;
            cursor: default;
          }
          .table-card {
            overflow: visible !important;
          }
          .table-wrapper {
            overflow-x: auto;
            overflow-y: visible !important;
            position: relative;
          }
          .table td, .table th { user-select: text; }

          /* Dropdown menu over table (like AddGuardian.js) */
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }
          .table td {
            overflow: visible !important;
          }
          .table tbody tr {
            overflow: visible !important;
          }
          .dropdown-menu {
            z-index: 9999 !important;
            position: absolute !important;
          }
        `}
      </style>

      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: '12px',
          paddingRight: '12px'}}
      >

        
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
                gap: '12px'}}
            >
              <div
                className="d-flex align-items-center gap-3"
                style={{ flex: 1, minWidth: 0 }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0}}
                >
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>
                <div style={{ minWidth: 0 }}>
                  <h3
                    className="m-0 fw-bold page-title text-start"
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: isMobile ? '14px' : 'clamp(18px, 2.5vw, 22px)',
                      lineHeight: '1.2'}}
                  >
                    Assign Students to Vehicle
                  </h3>
                  {/* <p
                    className="m-0 mt-0 text-start"
                    style={{ fontSize: isMobile ? '10px' : '13px', color: '#6b7280' }}
                  >
                    Assign Students to Vehicle
                  </p> */}
                </div>

              </div>

              {!isMobile && (
                <div className="d-flex align-items-center gap-3" style={{ justifyContent: 'flex-end' }}>
                  <ProfileDropdown
                    logout={logout}
                    notificationCount={3}
                    showNotifications={true}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <Container
          fluid
          className="p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >

                              <div className="d-flex justify-content-between align-items-center mb-4">
            
            {/* LEFT SIDE */}
            <div className="d-flex align-items-center gap-3">
              
              {/* Show Per Page */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ fontSize: '13px', color: '#6b7280' }}>
                  Show:
                </span>
          
                <Form.Select
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    height: '36px',
                    fontSize: '13px',
                    borderRadius: '6px'}}
                >
                  <option value="10">10 per page</option>
                  <option value="20">20 per page</option>
                  <option value="30">30 per page</option>
                </Form.Select>
              </div>
          
              {/* Filter Button */}
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'}}
              >
                <BsFunnelFill size={18} />
              </button>
          
            </div>
          
            {/* RIGHT SIDE */}
            {/* <button onClick={assignBus}
              
              style={{
                borderRadius: '10px',
                padding: '6px 12px',
                height: '44px',
                border: 'none',
                backgroundColor: '#223843',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                whiteSpace: 'nowrap'
              }}
            >
              <FaBus size={18} />
              <span style={{ fontSize: '12px', fontWeight: '600' }}>
                Assign Vehicel
              </span>
            </button> */}

            {selectedStudents.length > 0 && (
  <button onClick={assignBus} 
  className='bg-success'
    style={{
      borderRadius: '10px',
      padding: '6px 12px',
      height: '44px',
      border: 'none',
      // backgroundColor: 'success',
      color: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      whiteSpace: 'nowrap'
    }}
  >
    <FaBus size={18} />
    <span style={{ fontSize: '12px', fontWeight: '600' }}>
      Assign {selectedStudents.length} Students
    </span>
  </button>
)}
          
          </div>
          
          
          
                                
                                   {/* Modern Filter Section */}
                                          <div 
                                            style={{
                                              maxHeight: showFilterCard ? '1000px' : '0',
                                              // overflow: 'hidden',
                                              overflow: showFilterCard ? 'visible' : 'hidden',
                                              transition: 'max-height 0.3s ease-in-out',
                                              marginBottom: showFilterCard ? '24px' : '0'}}
                                          >
                                            {showFilterCard && (
                                              <Card 
                                                style={{
                                                  border: '1px solid #D1D3D4',
                                                  borderRadius: '12px',
                                                  backgroundColor: '#ffffff',
                                                  overflow: 'visible'}}
                                              >
                                                {/* Header */}
                                                <div 
                                                  style={{
                                                    background: '#ffffff',
                                                    padding: '20px',
                                                    borderBottom: '1px solid #F3F4F6'}}
                                                >
                                                  <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex align-items-center gap-3">
                                                      <div 
                                                        style={{
                                                          width: '40px',
                                                          height: '40px',
                                                          borderRadius: '50%',
                                                          backgroundColor: '#223843',
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent: 'center'}}
                                                      >
                                                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                                                      </div>
                                                      <div>
                                                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                                          Search Transport
                                                        </h5>
                                                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                                                          Find quickly by name, phone, or email
                                                        </p>
                                                      </div>
                                                    </div>
                                                    <div className="d-flex gap-2">
                                                      <button
                                                        onClick={handleRefresh}
                                                        style={{
                                                          width: '48px',
                                                          height: '48px',
                                                          borderRadius: '50%',
                                                          backgroundColor: '#223843',
                                                          border: 'none',
                                                          color: '#ffffff',
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent: 'center',
                                                          cursor: 'pointer',
                                                          transition: 'all 0.2s ease'}}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor = '#223843'
                                                          e.currentTarget.style.transform = 'scale(1.05)'
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor = '#223843'
                                                          e.currentTarget.style.transform = 'scale(1)'
                                                        }}
                                                        title="Refresh"
                                                      >
                                                        <BsArrowClockwise size={20} />
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                
                                                 <Card.Body ref={tableRef} className="p-4" style={{ backgroundColor: '#ffffff' }}>
                                                                                              <Row className="g-4 text-start">
                                                                                                
                                                                                                {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                                                                                                  <Col xs={12}>
                                                                                                    <div style={{ 
                                                                                                      padding: '20px', 
                                                                                                      backgroundColor: '#F3F4F6', 
                                                                                                      borderRadius: '8px',
                                                                                                      border: '1px solid #D1D3D4'}}>
                                                                                                      <div className="d-flex align-items-center gap-2 mb-3">
                                                                                                        <div 
                                                                                                          style={{
                                                                                                            width: '32px',
                                                                                                            height: '32px',
                                                                                                            borderRadius: '50%',
                                                                                                            backgroundColor: '#223843',
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            justifyContent: 'center'}}
                                                                                                        >
                                                                                                          <BsFunnelFill style={{ color: '#ffffff', fontSize: '16px' }} />
                                                                                                        </div>
                                                                                                        <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                                                                                          Filter by Course, Class & Student
                                                                                                        </label>
                                                                                                      </div>
                                                                                                      <SelectableField
                                                                                                        onSelect={handleFilterSelect}
                                                                                                        showCourse={true}
                                                                                                        showClass={true}
                                                                                                        showStudent={true}
                                                                                                        
                                                                                                        // abc={'abc'}
                                                                                                        setData={setData}
                                                                                                        resetTrigger={resetKey}
                                                
                                                                                                        
                                                                                                      />
                                                                                                    </div>
                                                                                                  </Col>
                                                                                                )}
                                                
                                                
                                                
                                                                                                </Row>
                                                                                                </Card.Body> 

                                                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                                                  <Row className="g-3">
                                                    <Col xs={12}>
                                                      <div style={{ position: 'relative' }}>
                                                        <div className="d-flex align-items-center gap-2 mb-3">
                                                          <div
                                                            style={{
                                                              width: '32px',
                                                              height: '32px',
                                                              borderRadius: '50%',
                                                              backgroundColor: '#10B981',
                                                              display: 'flex',
                                                              alignItems: 'center',
                                                              justifyContent: 'center'}}
                                                          >
                                                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                                                          </div>
                                                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                                            Filter by Student Name & Admission Date
                                                          </label>
                                                        </div>
                                                        <div style={{ position: 'relative' }}>
                                                          <BsSearch 
                                                            style={{ 
                                                              position: 'absolute', 
                                                              left: '12px', 
                                                              top: '50%', 
                                                              transform: 'translateY(-50%)',
                                                              color: '#6b7280',
                                                              fontSize: '16px',
                                                              zIndex: 1}} 
                                                          />
                                                          <Form.Control
                                                            type="text"
                                                            placeholder="Enter student name / admission number..."
                                                            value={search}
                                                            onChange={(e) => setSearch(e.target.value)}
                                                            style={{
                                                              paddingLeft: '40px',
                                                              borderRadius: '8px',
                                                              border: '1px solid #D1D3D4',
                                                              fontSize: '14px',
                                                              height: '40px',
                                                              transition: 'all 0.2s ease',
                                                              backgroundColor: '#ffffff',
                                                              fontFamily: 'Inter, system-ui, sans-serif'}}
                                                            onFocus={(e) => {
                                                              e.target.style.borderColor = '#223843'
                                                            }}
                                                            onBlur={(e) => {
                                                              e.target.style.borderColor = '#D1D3D4'
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                  
                                                </Card.Body>
                                                
                                              </Card>
                                              
                                              
                                            )}
                                          </div>



          {/* Dedicated Add New button (matches AddStudent.js UX placement) */}

          {/* <div className="d-flex justify-content-end align-items-center mb-4">
           
              <button
                onClick={assignBus}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New"
              >
                <FaBus size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Bus Assigned Students 
                </span>
              </button>
          </div> */}


          <Card
            className="table-card"
            style={{
              border: '1px solid #D1D3D4',
              borderRadius: '12px',
              overflow: 'visible',
              backgroundColor: '#ffffff',
              position: 'relative'}}
          >
            <div
              className="table-wrapper"
              style={{
                overflowX: 'auto',
                overflowY: 'visible',
                position: 'relative',
                borderRadius: '12px'}}
            >

              <Table
                className="table mb-0"
                style={{
                  borderRadius: '12px',
                  overflow: 'visible',
                  position: 'relative',
                  marginBottom: '0'}}
              >
                <Thead>
                  <Tr style={{ backgroundColor: '#F3F4F6' }}>
                    {/* {[
                      // 'ID',
                      'Select',
                      'Addmission Number',
                      'Name',
                      'Father Name',
                      'Email',
                      // 'Owner Number',
                      // 'Bus User',
                      // 'Status',
                      // 'Action',
                    ].map((h) => (
                      <Th
                        key={h}
                        style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          padding: '16px',
                          border: 'none',
                          borderBottom: '1px solid #D1D3D4',
                          textAlign: 'left',
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap'}}
                      >
                        {h}
                      </Th>
                    ))} */}

                    <Th style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          padding: '16px',
                          border: 'none',
                          borderBottom: '1px solid #D1D3D4',
                          textAlign: 'left',
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap'}}>
  <input
    type="checkbox"
    onChange={handleSelectAll}
    checked={
      currentStudents.length > 0 &&
      currentStudents.every((s) => selectedStudents.includes(s.id))
    }
  /> Select All
</Th>

<Th style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          padding: '16px',
                          border: 'none',
                          borderBottom: '1px solid #D1D3D4',
                          textAlign: 'left',
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap'}}>Addmission Number</Th>
<Th style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          padding: '16px',
                          border: 'none',
                          borderBottom: '1px solid #D1D3D4',
                          textAlign: 'left',
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap'}}>Name</Th>
<Th style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          padding: '16px',
                          border: 'none',
                          borderBottom: '1px solid #D1D3D4',
                          textAlign: 'left',
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap'}}>Father Name</Th>
<Th style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          padding: '16px',
                          border: 'none',
                          borderBottom: '1px solid #D1D3D4',
                          textAlign: 'left',
                          color: '#111827',
                          fontFamily: 'Inter, system-ui, sans-serif',
                          whiteSpace: 'nowrap'}}>Email</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentStudents.length === 0 ? (
  <Tr>
    <Td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
      No students found
    </Td>
  </Tr>
) : (
                    currentStudents.map((r, index) => (
                    <Tr
                      key={r.id}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                        transition: 'background-color 0.2s ease',
                        borderBottom: '1px solid #E5E7EB'}}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor =
                          index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                      }}
                    >
                      {[
                        
                        // r.driver_name,
                        // r.driver_contact_number,
                        <input
          type="checkbox"
          checked={selectedStudents.includes(r.id)}
          onChange={() => handleSelect(r.id)}
        />,
                        r.admission_number,
                        r.name,
                        r.father_name,
                        r.email
                        // r.bus_owner_number,
                        // '-',
                        // 'All',
                      ].map((val, i) => (
                        <Td
                          key={`${r.id}-${i}`}
                          style={{
                            fontSize: '14px',
                            padding: '16px',
                            border: 'none',
                            color: '#111827',
                            textAlign: 'left',
                            fontFamily: 'Inter, system-ui, sans-serif',
                            whiteSpace: 'nowrap'}}
                        >
                          {val}
                        </Td>
                      ))}




                      

                    </Tr>
                  )))}
                </Tbody>
                
              </Table>
            </div>
          </Card>
          <TablePagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            indexOfFirstItem={indexOfFirstItem}
            indexOfLastItem={indexOfLastItem}
            totalItems={filteredStudents.length}
            itemLabel="students"
            className="d-flex justify-content-between align-items-center mb-3 mt-4"
            wrapperStyle={{ flexWrap: 'nowrap' }}
          />






        </Container>
      </div>
    </>
  )
}















// import React, { useEffect, useState } from 'react'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// import { BASE_URL } from './commonComponents/ApiEndpoints'
// import { Table, Button, Form } from 'react-bootstrap'
// import toast from 'react-hot-toast'

// const AssignBusToStudent = ({ busId }) => {
//  const [students, setStudents] = useState([])
//   const [selectedStudents, setSelectedStudents] = useState([])

//   // ✅ Fetch all students
//   useEffect(() => {
//     fetchStudents()
//   }, [])

//   const fetchStudents = async () => {
//     try {
//       const instituteId = Cookies.get('institute_id')
//       const user = JSON.parse(Cookies.get('user') || '{}')

//       const res = await axios.get(`${BASE_URL}/student/all`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           'Institute-Id': Number(instituteId),
//         },
//       })

//       setStudents(res.data?.data || [])
//     } catch (error) {
//       console.error(error)
//       toast.error('Failed to fetch students')
//     }
//   }

//   // ✅ Handle checkbox (single)
//   const handleSelect = (studentId) => {
//     setSelectedStudents((prev) =>
//       prev.includes(studentId)
//         ? prev.filter((id) => id !== studentId)
//         : [...prev, studentId]
//     )
//   }

//   // ✅ Select All
//   const handleSelectAll = () => {
//     if (selectedStudents.length === students.length) {
//       setSelectedStudents([])
//     } else {
//       setSelectedStudents(students.map((s) => s.id))
//     }
//   }

//   // ✅ Assign Bus API (single + multiple)
//   const assignBus = async () => {
//     if (selectedStudents.length === 0) {
//       return toast.error('Select at least one student')
//     }

//     try {
//       const instituteId = Cookies.get('institute_id')
//       const user = JSON.parse(Cookies.get('user') || '{}')

//       const headers = {
//         Authorization: `Bearer ${user.token}`,
//         'Content-Type': 'application/json',
//         'Institute-Id': Number(instituteId),
//       }

//       // 🔥 Loop for multiple students
//       await Promise.all(
//         selectedStudents.map((studentId) =>
//           axios.post(
//             `${BASE_URL}/transport/assign-bus`,
//             {
//               student_id: studentId,
//               bus_id: busId,
//             },
//             { headers }
//           )
//         )
//       )

//       toast.success('Bus assigned successfully 🚀')
//       setSelectedStudents([])

//     } catch (error) {
//       console.error(error)
//       toast.error('Assignment failed')
//     }
//   }//  

//   return (
//     <div className="p-3" style={{ marginLeft: '260px', padding: '20px' }}>

//       <h4 className="mb-3">Assign Bus to Students (Bus ID: {busId})</h4>

//       {/* Assign Button */}
//       <Button variant="dark" className="mb-3" onClick={assignBus}>
//         Assign Selected Students
//       </Button>

//       <Table bordered hover responsive>
//         <thead>
//           <tr>
//             <th>
//               <Form.Check
//                 type="checkbox"
//                 checked={selectedStudents.length === students.length}
//                 onChange={handleSelectAll}
//               />
//             </th>
//             <th>Admission Number</th>
//             <th>Name</th>
//             <th>Father's Name</th>
//             <th>Email</th>
//           </tr>
//         </thead>

//         <tbody>
//           {students.map((student) => (
//             <tr key={student.id}>
//               <td>
//                 <Form.Check
//                   type="checkbox"
//                   checked={selectedStudents.includes(student.id)}
//                   onChange={() => handleSelect(student.id)}
//                 />
//               </td>

//               <td>{student.admission_number || 'N/A'}</td>
//               <td>{student.name || 'N/A'}</td>
//               <td>{student.father_name || 'N/A'}</td>
//               <td>{student.email || 'N/A'}</td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>
//     </div>
//   )
// }

// export default AssignBusToStudent